$ const {
  status = "attention",
  class: inputClass,
  ...noticeBaseInput
} = input;
<ebay-notice-base ...noticeBaseInput class=[`inline-notice--${status}`, inputClass] status=status prefixClass="inline-notice" root="div" headerRoot="span" mainRoot="span" noA11yLabel/>